import Alcatel from "./Alcatel.json"
import Apple from "./Apple.json"
import CAT from "./CAT.json"
import Fairphone from "./Fairphone.json"
import Fujitsu from "./Fujitsu.json"
import Google from "./Google.json"
import Huawei from "./Huawei.json"
import iTel from "./iTel.json"
import Lava from "./Lava.json"
import Lg from "./Lg.json"
import Motorola from "./Motorola.json"
import NokiaHmd from "./NokiaHmd.json"
import Nothing from "./Nothing.json"
import Olla from "./Olla.json"
import Oneplus from "./Oneplus.json"
import Oppo from "./Oppo.json"
import Realme from "./Realme.json"
import Samsung from "./Samsung.json"
import Sharp from "./Sharp.json"
import Sony from "./Sony.json"
import Tecno from "./Tecno.json"
import Vivo from "./Vivo.json"
import Vsmart from "./Vsmart.json"
import Wiko from "./Wiko.json"
import Xiaomi from "./Xiaomi.json"




const DevicesList=[
    Alcatel,Apple,CAT,Fairphone,Fujitsu,Google,Huawei,iTel,Lava,Lg,Motorola,NokiaHmd,Nothing,Olla,Oneplus,Oppo,Realme,Samsung,Sharp,Sony,
    Tecno,Vivo,Vsmart,Wiko,Xiaomi

]
    

export default DevicesList
